export const state = {
  suppliers: [],
  systemSupplier: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/suppliers/state.js